import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/ClaimManager`;;

const env = process.env;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiClaimManager = {
  // getAllClaimsWithRoleAccess: (params) => {
  //     const url = `${baseServiceUrl}/getAllClaimsWithRoleAccess`+ paramsToStringList(params);
  //     return ServiceApi.get(url, params);
  // },
  // getAllClaimsWithUserAccess: (params) => {
  //     const url = `${baseServiceUrl}/getAllClaimsWithUserAccess`+ paramsToStringList(params);
  //     return ServiceApi.get(url, params);
  // },
  getTreePermission: (params) => {
    const url = `${baseServiceUrl}/getTreePermission`;
    return ServiceApi.get(url, params);
  },

  getTreePermissionAgent: (params) => {
    const url = `${baseServiceUrl}/getTreePermission`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_Agent });
  },

};

export default ApiClaimManager;
